import axios from "../../../../api/axios";
import { FootballFacility } from "../types/footballFacilities.types";

export const getFootballFacilities = async (): Promise<FootballFacility[]> => {
  const response = await axios.get("/football-facilities");

  return response.data.data;
};
